export default {
  httpLinkUrl: process.env.REACT_APP_HTTP_LINK || '',
  wsLinkUrl: process.env.REACT_APP_WS_LINK || ''
}
